/**
 * 财务业务协作接口封装（走现有 http，accessToken 鉴权）。
 * 红线：所有"放行/确认"仅记录标记，后端绝不调用任何 Gate 写接口。
 * @author niebu
 */
import http from './httpRequest.js'

export default {
	// 当前用户角色
	me() {
		return http({ url: '/biz/me', method: 'GET' });
	},

	// ---------- 群聊订单面板 ----------
	orderContext(groupId) {
		return http({ url: `/biz/group/${groupId}/order-context`, method: 'GET' });
	},
	groupOrders(groupId, pageNo = 1, pageSize = 20) {
		return http({ url: `/biz/group/${groupId}/orders`, method: 'GET', params: { pageNo, pageSize } });
	},
	membersForAssign(groupId) {
		return http({ url: `/biz/group/${groupId}/members-for-assign`, method: 'GET' });
	},
	// 商户全部业务群成员(跨群去重): 临时会话无群上下文,按商户拉分配候选
	merchantMembersForAssign(merchantId) {
		return http({ url: `/biz/merchant/${merchantId}/members-for-assign`, method: 'GET' });
	},
	// 分配建议:该交易方上次接待的业务员(老客默认分配同一人)
	suggestSales(receiptId) {
		return http({ url: `/biz/receipt/${receiptId}/suggest-sales`, method: 'GET' });
	},
	// 候选买家手机号(扫临时会话聊天记录识别,供分配时筛选/自动填充)
	receiptPhones(receiptId) {
		return http({ url: '/biz/receipt/phones', method: 'GET', params: { receiptId } });
	},

	// ---------- 电销池(交叉电话销售) ----------
	telesalesPool(groupId) {
		return http({ url: '/biz/telesales/pool', method: 'GET', params: { groupId } });
	},
	telesalesCall(data) {
		return http({ url: '/biz/telesales/call', method: 'POST', data });
	},
	telesalesHistory(receiptId) {
		return http({ url: '/biz/telesales/history', method: 'GET', params: { receiptId } });
	},
	telesalesClaim(receiptId) {
		return http({ url: '/biz/telesales/claim', method: 'POST', data: { receiptId } });
	},
	telesalesAssign(receiptId, assigneeId) {
		return http({ url: '/biz/telesales/assign', method: 'POST', data: { receiptId, assigneeId } });
	},
	telesalesMembers(receiptId) {
		return http({ url: '/biz/telesales/members', method: 'GET', params: { receiptId } });
	},
	telesalesRelease(receiptId) {
		return http({ url: '/biz/telesales/release', method: 'POST', data: { receiptId } });
	},
	telesalesMine(groupId, tab) {
		return http({ url: '/biz/telesales/mine', method: 'GET', params: { groupId, tab } });
	},

	// ---------- 电话会话(老聊天库含电话线索,仅财务/管理员) ----------
	legacyPhoneUsers(page = 1, pageSize = 20, filter = 'all') {
		return http({ url: '/biz/legacy/phone-users', method: 'GET', params: { page, pageSize, filter } });
	},
	legacyPhoneConvs(uid) {
		return http({ url: '/biz/legacy/phone-convs', method: 'GET', params: { uid } });
	},
	legacyPhoneMark(a, b, data) {
		return http({ url: '/biz/legacy/phone-mark', method: 'POST', data: Object.assign({ a, b }, data) });
	},
	legacyPhoneFavs() {
		return http({ url: '/biz/legacy/phone-favs', method: 'GET' });
	},
	legacyPhoneRefresh() {
		return http({ url: '/biz/legacy/phone-refresh', method: 'GET' });
	},
	legacyPhoneMsgs(a, b, onlyPhone = false) {
		return http({ url: '/biz/legacy/phone-msgs', method: 'GET', params: { a, b, onlyPhone } });
	},
	legacyPhoneReads() {
		return http({ url: '/biz/legacy/phone-reads', method: 'GET' });
	},
	legacyAdmins() {
		return http({ url: '/biz/legacy/admins', method: 'GET' });
	},
	legacyAdminMark(data) {
		return http({ url: '/biz/legacy/admin-mark', method: 'POST', data });
	},
	legacyMsgFavs() {
		return http({ url: '/biz/legacy/msg-favs', method: 'GET' });
	},
	legacyMsgFav(data) {
		return http({ url: '/biz/legacy/msg-fav', method: 'POST', data });
	},
	legacyMsgFavDel(id) {
		return http({ url: '/biz/legacy/msg-fav-del', method: 'POST', data: { id } });
	},
legacyMsgFavExported(ids) {
		return http({ url: '/biz/legacy/msg-fav-exported', method: 'POST', data: { ids } });
	},

	// ---------- 工作流动作 ----------
	assign(receiptId, salespersonId, customerId, groupId, buyerPhone) {
		const data = { receiptId, salespersonId };
		if (customerId) data.customerId = customerId;
		// 传当前面板所在群：分配消息及后续通知仅发此群，不广播商户其它群
		if (groupId) data.groupId = groupId;
		if (buyerPhone) data.buyerPhone = buyerPhone;
		return http({ url: '/biz/receipt/assign', method: 'POST', data });
	},
	// 财务转单：分配错业务员时改派（仅「待确认收款」flowStatus=1 阶段可操作）
	reassign(receiptId, salespersonId, groupId) {
		const data = { receiptId, salespersonId };
		if (groupId) data.groupId = groupId;
		return http({ url: '/biz/receipt/reassign', method: 'POST', data });
	},
	confirm(receiptId, payChannel) {
		return http({ url: '/biz/receipt/confirm', method: 'POST', data: { receiptId, payChannel } });
	},
	markReleased(receiptId) {
		return http({ url: '/biz/receipt/mark-released', method: 'POST', data: { receiptId } });
	},
	transfer(receiptId) {
		return http({ url: '/biz/receipt/transfer', method: 'POST', data: { receiptId } });
	},
	financeReceived(receiptId) {
		return http({ url: '/biz/receipt/finance-received', method: 'POST', data: { receiptId } });
	},
	// 取消订单(财务或对接业务员,必填原因)
	cancelReceipt(receiptId, reason) {
		return http({ url: '/biz/receipt/cancel', method: 'POST', data: { receiptId, reason } });
	},
	// 手动同步买家付款状态(只读Gate,解决自动轮询遗漏)
	syncPaid(receiptId) {
		return http({ url: '/biz/receipt/sync-paid', method: 'POST', data: { receiptId } });
	},
	// OSS图片URL批量迁移(用户/群/群成员头像)
	migrateImages() {
		return http({ url: '/biz/admin/migrate-images', method: 'POST' });
	},

	// ---------- 客户档案（Phase D） ----------
	// 客户状态字典(启用项) — 旧接口保留，前端不再调用
	customerStatusList() {
		return http({ url: '/biz/customer-status/list', method: 'GET' });
	},
	// 按订单获取对手方客户档案(回填)
	customerByReceipt(receiptId) {
		return http({ url: '/biz/customer/by-receipt', method: 'GET', params: { receiptId } });
	},
	// 填写/更新对手方客户档案(按 its_uid 去重,真实姓名自动取对手方,传等级+备注+客户微信)
	// wechatId 后端必填：业务员微信被封后靠它找回客户，也是回款(transfer)的前置检查项
	customerSave(receiptId, level, remark, wechatId, wechatNick) {
		return http({
			url: '/biz/customer/save', method: 'POST',
			data: { receiptId, level, remark, wechatId, wechatNick }
		});
	},
	// 我的客户列表(管理员看全部,业务员看自己的,带订单统计)
	// dealt: true=仅成交, false=仅未成交, 不传=全部
	customerMyList(params) {
		return http({ url: '/biz/customer/my-list', method: 'GET', params });
	},
	// 修改客户等级
	customerUpdateLevel(customerId, level) {
		return http({ url: '/biz/customer/update-level', method: 'POST', data: { customerId, level } });
	},
	// 修改客户微信号(业务员本人或管理员)
	customerUpdateWechat(customerId, wechatId, wechatNick) {
		return http({ url: '/biz/customer/update-wechat', method: 'POST', data: { customerId, wechatId, wechatNick } });
	},
	// 修改客户备注(业务员本人或管理员)
	customerUpdateRemark(customerId, remark) {
		return http({ url: '/biz/customer/update-remark', method: 'POST', data: { customerId, remark } });
	},
	// 客户详情(含关联订单列表)
	customerDetail(customerId) {
		return http({ url: '/biz/customer/detail', method: 'GET', params: { customerId } });
	},
	// 客户等级统计
	customerLevelStats(params) {
		return http({ url: '/biz/customer/level-stats', method: 'GET', params });
	},

	// ---------- 财务统计大屏（Phase C） ----------
	statsMerchants() {
		return http({ url: '/biz/stats/merchants', method: 'GET' });
	},
	// 商户成交率(芝麻后台实时口径:成功放币÷(放币+取消),后端逐笔终态同步刷新)
	statsCloseRate(merchantId) {
		return http({ url: '/biz/stats/close-rate', method: 'GET', params: { merchantId } });
	},
	statsOverview(params) {
		return http({ url: '/biz/stats/overview', method: 'GET', params });
	},
	// 按天统计(队长每日记账:交易笔数/成交/取消/卖出U/卖出人民币)
	statsDaily(params) {
		return http({ url: '/biz/stats/daily', method: 'GET', params });
	},
	statsOrders(params) {
		return http({ url: '/biz/stats/orders', method: 'GET', params });
	},
	orderDetail(merchantId, txid) {
		return http({ url: '/biz/order/detail', method: 'GET', params: { merchantId, txid } });
	},
	// 收款流水分页(财务看全部,可按 flowStatus 筛选)
	receiptPage(params) {
		return http({ url: '/biz/receipt/page', method: 'GET', params });
	},

	// ---------- 买家黑名单（仅提示） ----------
	// 启用中的黑名单姓名列表(供订单列表标红比对)
	blacklistNames() {
		return http({ url: '/biz/blacklist/names', method: 'GET' });
	},

	// ---------- 客勤填报（业务员） ----------
	// 启用客勤字段(供填报表单渲染)
	kqFields() {
		return http({ url: '/biz/kq/fields', method: 'GET' });
	},
	// 当前业务员某天的填报(回显)
	kqMyReport(date) {
		return http({ url: '/biz/kq/my-report', method: 'GET', params: { date } });
	},
	// 提交客勤填报(按日覆盖,可附客勤群id)
	kqReportSubmit(date, content, kqGroupId) {
		return http({ url: '/biz/kq/report/submit', method: 'POST', data: { date, content, kqGroupId } });
	},
	// 历史填报分页
	kqReportHistory(params) {
		return http({ url: '/biz/kq/report/history', method: 'GET', params });
	},
	// 客勤群检查(当前群是否绑定客勤群/可否填报)
	kqGroupCheck(groupId) {
		return http({ url: '/biz/kq/group-check', method: 'GET', params: { groupId } });
	},

	// ---------- 客情统计（财务） ----------
	// 业务员列表(财务筛选下拉)
	salespersons() {
		return http({ url: '/biz/salespersons', method: 'GET' });
	},
	// 日/周/月聚合统计 { period, from, to, salespersonId?, kqGroupId? }
	kqStats(params) {
		return http({ url: '/biz/kq/stats', method: 'GET', params });
	},
	// 填报明细分页 { from, to, salespersonId?, kqGroupId?, pageNo, pageSize }
	kqReports(params) {
		return http({ url: '/biz/kq/reports', method: 'GET', params });
	},

	// ---------- 报告分享（业务员） ----------
	// 报告列表 + 当前业务员的分享编号与专属链接
	reportList() {
		return http({ url: '/biz/report/list', method: 'GET' });
	},
	// 查看我的分享配置(分享编号/水印文案)
	reportMyShare() {
		return http({ url: '/biz/report/my-share', method: 'GET' });
	},
	// 自定义我的水印文案
	reportUpdateWatermark(watermarkText) {
		return http({ url: '/biz/report/my-share/watermark', method: 'POST', data: { watermarkText } });
	},
	// 设置我的微信号(领取邮件内展示)
	reportUpdateWechat(wechatId) {
		return http({ url: '/biz/report/my-share/wechat', method: 'POST', data: { wechatId } });
	},
	// 设置我的邮件发件人名称(空用全局默认)
	reportUpdateSender(senderName) {
		return http({ url: '/biz/report/my-share/sender', method: 'POST', data: { senderName } });
	},
	// 申请我的专属主域名(后台审核通过后生效)
	reportApplyDomain(domain) {
		return http({ url: '/biz/report/my-share/domain-apply', method: 'POST', data: { domain } });
	},
	// 生成我的专属分享链接二维码
	reportQrcode(reportId) {
		return http({ url: '/biz/report/qrcode', method: 'GET', params: { reportId } });
	},

	// ---------- 工作台报告管理(需后台开通 can_manage) ----------
	// 是否有管理权限
	reportManagePerm() {
		return http({ url: '/biz/report/manage/perm', method: 'GET' });
	},
	// 管理用报告列表(含停用)
	reportManageList() {
		return http({ url: '/biz/report/manage/list', method: 'GET' });
	},
	// 新增/编辑报告
	reportManageSave(data) {
		return http({ url: '/biz/report/manage/save', method: 'POST', data });
	},
	// 删除报告
	reportManageDelete(id) {
		return http({ url: '/biz/report/manage/delete', method: 'POST', data: { id } });
	},
	// 启用/停用报告
	reportManageToggle(id, enabled) {
		return http({ url: '/biz/report/manage/toggle', method: 'POST', data: { id, enabled } });
	},
	// 上传报告PDF
	reportManageUploadFile(formData) {
		return http({ url: '/biz/report/manage/upload-file', method: 'POST', data: formData, headers: { 'Content-Type': 'multipart/form-data' } });
	},
	// 上传封面图
	reportManageUploadImage(formData) {
		return http({ url: '/biz/report/manage/upload-image', method: 'POST', data: formData, headers: { 'Content-Type': 'multipart/form-data' } });
	},
	// 渲染PDF指定页为预览图
	reportManagePdfPreview(pdfUrl, page) {
		return http({ url: '/biz/report/manage/pdf-preview', method: 'POST', data: { pdfUrl, page } });
	},
	// 渲染PDF全部页为缩略图
	reportManagePdfAllPages(pdfUrl) {
		return http({ url: '/biz/report/manage/pdf-all-pages', method: 'POST', data: { pdfUrl } });
	},

	// ---------- 链接追踪（业务员） ----------
	// 我的追踪链接列表
	trackLinks() {
		return http({ url: '/biz/track/links', method: 'GET' });
	},
	// 创建追踪链接
	trackCreate(data) {
		return http({ url: '/biz/track/links', method: 'POST', data });
	},
	// 更新追踪链接
	trackUpdate(id, data) {
		return http({ url: '/biz/track/links/' + id, method: 'PUT', data });
	},
	// 删除追踪链接
	trackDelete(id) {
		return http({ url: '/biz/track/links/' + id, method: 'DELETE' });
	},
	// 链接访问明细
	trackVisits(id) {
		return http({ url: '/biz/track/links/' + id + '/visits', method: 'GET' });
	},
	// 生成追踪链接二维码
	trackQrcode(id) {
		return http({ url: '/biz/track/links/' + id + '/qrcode', method: 'GET' });
	},
	// 设备库列表
	trackDevices() {
		return http({ url: '/biz/track/devices', method: 'GET' });
	},
	// 标记设备
	trackMarkDevice(id, mark, remark) {
		return http({ url: '/biz/track/devices/' + id + '/mark', method: 'PUT', data: { mark: mark || '', remark: remark || '' } });
	},
	// 热力图数据
	trackHeatmap(linkId) {
		return http({ url: '/biz/track/links/' + linkId + '/heatmap', method: 'GET' });
	},
	// 管理员: 查看所有业务员的追踪链接
	trackAdminLinks(userId) {
		var url = '/biz/track/admin/links';
		if (userId) url += '?userId=' + encodeURIComponent(userId);
		return http({ url: url, method: 'GET' });
	},
	// 管理员: 查看追踪链接访问明细
	trackAdminVisits(linkId) {
		return http({ url: '/biz/track/admin/visits/' + linkId, method: 'GET' });
	},
	// 管理员: 彻底删除追踪链接(仅限业务员已软删除的)
	trackAdminDelete(id) {
		return http({ url: '/biz/track/admin/links/' + id, method: 'DELETE' });
	},

	// ---------- 业务员接单微信配置(上粉群) ----------
	wechatMine() {
		return http({ url: '/biz/wechat/mine', method: 'GET' });
	},
	// 上粉群识别关键词(群入口展示判断)
	wechatFanKeyword() {
		return http({ url: '/biz/wechat/fan-keyword', method: 'GET' });
	},
	wechatSave(data) {
		return http({ url: '/biz/wechat/save', method: 'POST', data });
	},
	wechatDelete(id) {
		return http({ url: '/biz/wechat/delete', method: 'POST', data: { id } });
	},
	wechatSetActive(id, active) {
		return http({ url: '/biz/wechat/set-active', method: 'POST', data: { id, active } });
	},
	// 保存企业微信二维码(一人一份,覆盖保存;上传即选定发送方式为二维码)
	wechatSetQrcode(qrcodeUrl) {
		return http({ url: '/biz/wechat/set-qrcode', method: 'POST', data: { qrcodeUrl } });
	},
	// 设置微信接单发送方式(1=二维码图片 2=微信号,二选一必选)
	wechatSetSendType(sendType, wechatNo) {
		return http({ url: '/biz/wechat/set-send-type', method: 'POST', data: { sendType, wechatNo } });
	},

	// ---------- 业务员支付宝接单配置(收款配置) ----------
	alipayMine() {
		return http({ url: '/biz/alipay/mine', method: 'GET' });
	},
	alipaySave(data) {
		return http({ url: '/biz/alipay/save', method: 'POST', data });
	},
	alipaySetActive(active) {
		return http({ url: '/biz/alipay/set-active', method: 'POST', data: { active } });
	},

	// ---------- 财务分配看板 ----------
	// 同群多商户时传 merchantIds(逗号分隔)全部聚合,后端兼容单个 merchantId
	assignStats(merchantId, merchantIds) {
		const params = { merchantId };
		if (merchantIds) {
			params.merchantIds = merchantIds;
		}
		return http({ url: '/biz/receipt/assign-stats', method: 'GET', params });
	},

	// ---------- 考勤统计 ----------
	// 我的今日考勤(打卡按钮状态)
	attMyToday() {
		return http({ url: '/biz/attendance/my-today', method: 'GET' });
	},
	// 业务员打卡
	attPunch() {
		return http({ url: '/biz/attendance/punch', method: 'POST' });
	},
	// 每日看板(财务/管理员)
	attBoard(date) {
		return http({ url: '/biz/attendance/board', method: 'GET', params: { date } });
	},
	// 手动填写 {userId, date, status, remark}
	attFill(data) {
		return http({ url: '/biz/attendance/fill', method: 'POST', data });
	},
	// 确认打卡 {userId, date}
	attConfirm(data) {
		return http({ url: '/biz/attendance/confirm', method: 'POST', data });
	},
	// 清除记录 {userId, date}
	attClear(data) {
		return http({ url: '/biz/attendance/clear', method: 'POST', data });
	},
	// 月度统计 ?month=yyyy-MM
	attStats(month) {
		return http({ url: '/biz/attendance/stats', method: 'GET', params: { month } });
	},
	// 单人月度日历(财务/管理员) ?month=&userId=
	attCalendar(userId, month) {
		return http({ url: '/biz/attendance/calendar', method: 'GET', params: { userId, month } });
	},
	// 我的月度日历(本人) ?month=
	attMyCalendar(month) {
		return http({ url: '/biz/attendance/my-calendar', method: 'GET', params: { month } });
	},
	// 业务员请假 {date, status(2请假 3半天假), remark}
	attLeave(data) {
		return http({ url: '/biz/attendance/leave', method: 'POST', data });
	},
	// 休息日增删 {date, add}
	attRest(data) {
		return http({ url: '/biz/attendance/rest', method: 'POST', data });
	},

	// ---------- CoiAI优惠券管理(仅管理员) ----------
	// 发放优惠券 {monthlyPrice, yearlyPrice, validHours?, maxUses?, remark?, assignEmail?|assignUserId?}
	coiCreateCode(data) {
		return http({ url: '/biz/coiai/discount-codes', method: 'POST', data });
	},
	// 发放台账分页
	coiCodePage(pageNo = 1, pageSize = 20, keyword) {
		return http({ url: '/biz/coiai/discount-codes', method: 'GET', params: { pageNo, pageSize, keyword } });
	},
	// 刷新优惠码状态(调远端并回写台账)
	coiCodeStatus(id) {
		return http({ url: `/biz/coiai/discount-codes/${id}/status`, method: 'GET' });
	},
	// CoiAI注册用户列表 {search?, hasIosDevice?, page, perPage}
	coiUsers(params) {
		return http({ url: '/biz/coiai/users', method: 'GET', params });
	},
	// 发放iOS优惠券 {assignUserId?|assignEmail?, planScope, validHours?, remark?}
	coiCreateIosCoupon(data) {
		return http({ url: '/biz/coiai/ios-coupons', method: 'POST', data });
	}
}
